<template>
  <div>
    <div class="wrapper my-8 mx-8 d-flex flex-column">
      <p>
        <span style="color:rgb(0,170,221); cursor:pointer;" @click="$router.push('/')">Dashboard /</span> Patients
      </p>
      <h2 class="mt-6">Patients</h2>

      <div class="cell mt-10">
        <div class="my-3 mx-10" style="display:flex; align-items:center;">
          <p>Status:</p>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <p class="text-capitalize ml-2 black--text" v-on="on">
                {{statusSearch}}
                <v-icon small left>mdi-chevron-down</v-icon>
              </p>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in ['All','Active', 'Blocked']"
                :key="index"
              >
                <v-list-item-title
                  @click="statusSearch=item;currentPage=1;searchByStatus(item.toLowerCase());"
                >
                  <p>{{ item }}</p>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <p class="ml-4">Location:</p>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <p class="text-capitalize ml-2 black--text" v-on="on">
                {{country}}
                <v-icon small left>mdi-chevron-down</v-icon>
              </p>
            </template>
            <v-list max-height="600" style="overflow-y:auto;">
              <v-list-item v-for="(item, index) in $store.state.countries" :key="index">
                <v-list-item-title
                  @click="country=item.option_value;countryCode=item.option_key;currentPage=1;searchByStatus()"
                >
                  <p>{{ item.option_value }}</p>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <div class="mr-2 d-flex align-center">
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="search" label="Search.." color="rgb(0,170,221)"></v-text-field>
            <v-btn :loading="$store.state.loading" width="20" rounded text color="rgb(0,170,221)" class="ml-2" @click="searchByStatus()">
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </div>
        <v-divider class="mx-10"></v-divider>

        <div class="d-flex flex-column">
          <div class="mt-8 ml-10" style="display:flex; align-items:center; width:95%;">
            <p class="bold">{{entries}} entries</p>
            <v-spacer></v-spacer>
            <p>Sort by</p>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <p class="text-capitalize ml-2 black--text" v-on="on">
                  {{sortByText}}
                  <v-icon small left>mdi-chevron-down</v-icon>
                </p>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in [{text:'Date Registered (newest to oldest)',value:{sort: 'dateVerified', dir:'desc'}}, {text:'Date Registered (oldest to newest)', value:{sort:'dateVerified', dir:'asc'}}, {text:'Alphabetically (ascending)', value:{sort:'doctorName', dir:'asc'}}, {text:'Alphabetically (descending)', value:{sort:'doctorName', dir:'desc'}}]"
                  :key="index"
                  @click="sortByText=item.text;sortBy = item.value.sort; dir=item.value.dir; searchByStatus()"
                >
                  <v-list-item-title>
                    <p>{{ item.text }}</p>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <p class="text-capitalize ml-2 black--text" v-on="on">
                  Display
                  <v-icon small left>mdi-chevron-down</v-icon>
                </p>
              </template>
              <v-list>
                <v-list-item-group v-model="displayArray" multiple>
                  <template v-for="(item, i) in displayItems">
                    <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>

                    <v-list-item
                      v-else
                      :key="`item-${i}`"
                      :value="item"
                      active-class="rgb(0,169,221)"
                    >
                      <template v-slot:default="{ active, toggle }">
                        <v-list-item-content>
                          <v-list-item-title v-text="item"></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            :true-value="item"
                            color="rgb(0,169,221)"
                            @click="toggle"
                          ></v-checkbox>
                        </v-list-item-action>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
          <table class="justify-self-center mt-2 ml-10" style="width:95%;">
            <tr class="table-head">
              <th class="text-left" v-if="displayArray.includes('Name')">
                <p class="ml-2">Name</p>
              </th>
              <th class="text-left pl-2 statusCol" v-if="displayArray.includes('Status')">
                <p>Status</p>
              </th>
              <!-- <th class="text-left" v-if="displayArray.includes('Country')">
                <p>Country</p>
              </th>
              <th class="text-left" v-if="displayArray.includes('Type of Doctor')">
                <p>Type of Doctor</p>
              </th>-->

              <th class="text-left" v-if="displayArray.includes('Date Registered')">
                <p>Date Registered</p>
              </th>

              <th class="text-left">
                <p>Municipality</p>
              </th>
<!-- 
              <th class="text-left" v-if="displayArray.includes('Emergency Requests')">
                <p>Emergency Requests</p>
              </th> -->
              <!-- <th class="text-left">
                <p>
                  Accepted
                  <br />Emergencies
                </p>
              </th>
              <th class="text-left">
                <p>
                  Completed
                  <br />Appointments
                </p>
              </th>
              <th class="text-left">
                <p>
                  Avg Availability
                  <br />(last 10 days)
                </p>
              </th>-->
              <th class="text-left" v-if="displayArray.includes('Actions')">
                <p>Actions</p>
              </th>
            </tr>

            <tr class="table-data" v-if="$store.state.loading">
              <td>
                <v-skeleton-loader height="94" type="list-item-avatar-two-line"></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader height="94" type="list-item"></v-skeleton-loader>
              </td>

              <td>
                <v-skeleton-loader height="94" type="list-item"></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader height="94" type="list-item"></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader height="50" type="avatar"></v-skeleton-loader>
              </td>
            </tr>
            <tr class="table-data" v-if="$store.state.loading">
              <td>
                <v-skeleton-loader height="94" type="list-item-avatar-two-line"></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader height="94" type="list-item"></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader height="94" type="list-item"></v-skeleton-loader>
              </td>

              <td>
                <v-skeleton-loader height="94" type="list-item"></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader height="94" type="avatar"></v-skeleton-loader>
              </td>
            </tr>
            <tr class="table-data" v-if="$store.state.loading">
              <td>
                <v-skeleton-loader height="94" type="list-item-avatar-two-line"></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader height="94" type="list-item"></v-skeleton-loader>
              </td>

              <td>
                <v-skeleton-loader height="94" type="list-item"></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader height="94" type="list-item"></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader height="94" type="avatar"></v-skeleton-loader>
              </td>
            </tr>

            <tr class="table-data" v-if="$store.state.loading">
              <td>
                <v-skeleton-loader height="94" type="list-item-avatar-two-line"></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader height="94" type="list-item"></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader height="94" type="list-item"></v-skeleton-loader>
              </td>

              <td>
                <v-skeleton-loader height="94" type="list-item"></v-skeleton-loader>
              </td>
              <td>
                <v-skeleton-loader height="94" type="avatar"></v-skeleton-loader>
              </td>
            </tr>

           
             <router-link
              v-else
              tag="tr"
              
              class="table-data"
              v-for="(patient,index) in $store.state.patients.patients"
              :key="index"
              :to="'/patients/patient/'+patient.userProfile.userId"
              
            >
              <td v-if="displayArray.includes('Name')">
                <div class="ml-2" style="display:flex; align-items:center;">
                  <img
                    style="border-radius:50%; height:40px; width:40px;"
                    :src="patient.userProfile ? patient.userProfile.profilePic : ''"
                    alt="photo"
                  />
                  <div class="ml-2 d-flex flex-column">
                    <p
                      class="font-weight-medium black--text"
                    >
                    
                     <a style="text-decoration:none; color:inherit;cursor:pointer;" href="">
                        {{patient.userProfile ? patient.userProfile.firstName : ''}} {{patient.userProfile ? patient.userProfile.lastName : ''}}
                      </a>
                   </p>
                    <p class>{{patient.userProfile ? patient.userProfile.username : ''}}</p>
                  </div>
                </div>
              </td>

              <td v-if="displayArray.includes('Status')" class="pl-2 statusCol">
                <div class="d-flex align-center">
                  <div
                    class="d-flex justify-center align-center"
                    v-if="patient.userProfile.isBlocked"
                  >
                    <div style="height:8px;width:8px;border-radius:50%;" class="blocked"></div>
                    <p class="ml-2">Blocked</p>
                  </div>

                  <div class="d-flex justify-center align-center" v-else>
                    <div style="height:8px;width:8px;border-radius:50%;" class="green"></div>
                    <p class="ml-2">Active</p>
                  </div>
                </div>
              </td>

              <td v-if="displayArray.includes('Date Registered')">
                <p>{{patient.userProfile ? convertDate(patient.userProfile.createdAt) : ''}}</p>
              </td>

              <td>
                <p>{{patient.municipalityName}}</p>
              </td>

              <!-- <td v-if="displayArray.includes('Emergency Requests')">
                <p>TODO</p>
              </td> -->

              <td v-if="displayArray.includes('Actions')">
                <div class="d-flex align-center" style="cursor:pointer;">
                  <v-tooltip top v-if="patient.userProfile.isBlocked">
                    <template v-slot:activator="{ on }">
                      <img
                        v-on="on"
                        style="height:20px; width:20px;"
                        src="/img/approve.svg"
                        alt="ban"
                        @click.stop="selectedPatient=patient;unblockDialog=true"
                      />
                    </template>
                    <span>Unblock</span>
                  </v-tooltip>

                  <v-tooltip top v-else>
                    <template v-slot:activator="{ on }">
                      <img
                        v-on="on"
                        style="height:20px; width:20px;"
                        src="/img/ban.svg"
                        alt="ban"
                        @click.stop="selectedPatient=patient;blockDialog=true"
                      />
                    </template>
                    <span>Block</span>
                  </v-tooltip>
                </div>
              </td>
             </router-link>
          </table>
          <div class="d-flex justify-end" style="width:85%;">
            <div class="d-flex">
              <p>Rows per page:</p>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <p class="text-capitalize ml-2 black--text" v-on="on">
                    {{rowsPerPage}}
                    <v-icon small left>mdi-chevron-down</v-icon>
                  </p>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in [5,10,20,30,40,50]" :key="index">
                    <v-list-item-title
                      @click="rowsPerPage = item; currentPage=1;searchByStatus();"
                    >{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

            <div class="d-flex">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    :disabled="!!(currentPage==1 || currentPage==0)"
                    @click="currentPage--; searchByStatus()"
                  >mdi-chevron-left</v-icon>
                </template>
                <span>Previous</span>
              </v-tooltip>

              <p>
                Page
                <span class="black--text">{{currentPage}}</span>
                of {{totalPageCount}}
              </p>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    :disabled="!!(currentPage==totalPageCount || totalPageCount==0)"
                    @click="currentPage++; searchByStatus();"
                  >mdi-chevron-right</v-icon>
                </template>
                <span>Next</span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="blockDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>Block {{selectedPatient ? selectedPatient.userProfile.firstName : ''}} {{selectedPatient ? selectedPatient.userProfile.lastName : ''}}?</h1>
            <p class="text-center mt-4">
              Prevent this user from being able to request a doctor or book any appointments with doctors or healthcare facilities).
              However they are still allowed to login to make changes to their profile and access their history or other personal info.
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="blockDialog=false"
            >cancel</v-btn>
            <v-btn
              class="text-capitalize white--text"
              rounded
              color="rgb(255,0,0)"
              @click="block(selectedPatient)"
            >Block</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="unblockDialog" width="500">
      <v-card class="pt-12">
        <v-card-text>
          <div class="d-flex flex-column align-center justify-center">
            <h1>Unblock {{selectedPatient ? selectedPatient.userProfile.firstName : ''}} {{selectedPatient ? selectedPatient.userProfile.lastName : ''}}?</h1>
            <p class="text-center mt-4">
              This user will be re-activated and able to use your services again (request for a doctor in case of an emergency, book appointments etc).
            </p>
          </div>
          <div class="d-flex justify-center mt-4">
            <v-btn
              class="text-capitalize mr-2"
              outlined
              color="rgb(164,164,164)"
              rounded
              @click="unblockDialog=false"
            >cancel</v-btn>
            <v-btn
              class="text-capitalize white--text"
              rounded
              color="rgb(113,210,48)"
              @click="unblock(selectedPatient)"
            >Unblock</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("setActiveIndex", 3).then(() => {
      this.$store
        .dispatch("getAllPatients", {
          pageSize: this.rowsPerPage,
          pageNo: 1,
          activeStatus: "all",
          sortBy: this.sortBy,
          dir: this.dir,
          search: this.search
        })
        .then(res => {
          this.entries = res.data.totalCount;
          this.currentPage = res.data.currentPage;
          this.totalPageCount = res.data.totalPageCount;
        })
        .catch(err => {
          this.totalPageCount = 0;
        });
    });
  },
  data() {
    return {
      selectedPatient: null,

      country: "All",
      statusSearch: "All",
      sortByText: "Date Registered (newest to oldest)",
      dir: "desc",
      search: '',
      sortBy: "dateVerified",
      rowsPerPage: 10,
      totalPageCount: null,
      currentPage: 0,
      entries: 0,

      blockDialog: false,
      unblockDialog: false,

      displayArray: [
        "Name",
        "Status",
        "Emergency Requests",
        "Date Registered",
        "Actions"
      ],
      displayItems: [
        "Name",
        "Status",
        "Emergency Requests",
        "Date Registered",
        "Actions"
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    };
  },
  methods: {
    searchByStatus(status) {
      this.$store
        .dispatch("getAllPatients", {
          pageSize: this.rowsPerPage,
          pageNo: this.currentPage,
          activeStatus: this.statusSearch.toLowerCase(),
          sortBy: this.sortBy,
          dir: this.dir,
          country: this.countryCode,
          search: this.search
        })
        .then(res => {
          this.entries = res.data.totalCount;
          this.totalPageCount = res.data.totalPageCount;
          if (this.currentPage > this.totalPageCount) {
            console.log(this.currentPage, "current");
            console.log(this.totalPageCount, "total");
            console.log(this.currentPage, "current again");
          } else {
            this.currentPage = res.data.currentPage;
          }
        })
        .catch(err => {
          console.log("xaxahxaxahx");
          this.currentPage = 0;
          this.totalPageCount = 0;
        });
    },

     block(patient) {
      const credentials = {
        userId: patient.userProfile.userId,
        isBlocked: true
      };
      this.$store.dispatch("blockPatient", credentials).then(() => {
        this.blockDialog = false;
      });
    },
    unblock(patient) {
      const credentials = {
        userId: patient.userProfile.userId,
        isBlocked: false
      };
      this.$store.dispatch("unblockPatient", credentials).then(() => {
        this.unblockDialog = false;
      });
    },

    convertDate(date2) {
      const date = new Date(date2);
      const day = date.getDate();
      const month = date.getMonth();
      const year = date.getFullYear();
      return day + " " + this.months[month].substr(0, 3) + " " + year;
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
  color: rgb(107, 107, 107);
}

img {
  height: 35px;
  width: 35px;
}

.statusCol{
  max-width:10px;
}
</style>